import { GridFilterItem, GridSortModel } from '@mui/x-data-grid-pro';

import { GVOpportunity } from 'models/GoldVision/GVOpportunities';
import { createAsyncAction } from 'typesafe-actions';

export type GetAllGVOpportunitiesRequestPayload = {
  pagination_model: {
    page: number;
    page_size: number;
  };
  sort_model: GridSortModel;
  filter_model: GridFilterItem[];
};
export type GetAllGVOpportunitiesSuccessPayload = {
  data: {
    totalRowCount: number;
    data: GVOpportunity[];
  };
};

export const getAllGVOpportunities = createAsyncAction(
  'gvOpportunities/getAllGVOpportunities/request',
  'gvOpportunities/getAllGVOpportunities/success',
  'gvOpportunities/getAllGVOpportunities/failure',
)<
  GetAllGVOpportunitiesRequestPayload,
  GetAllGVOpportunitiesSuccessPayload,
  undefined
>();
